import { render, staticRenderFns } from "./CityEdit.vue?vue&type=template&id=1445bf3c&lang=pug"
import script from "./CityEdit.vue?vue&type=script&lang=js"
export * from "./CityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports